<template>
  <!-- accordion like settings-->

  <v-card class="fluid-column ma-5">

    <div>

      <v-card-text>
        

        <p class="text-headline-small">
          Utente</p>
        <!-- <p class="text-blue-darken-3 text-title-large text-uppercase font-weight-bold mt-3">
          <v-icon class="mr-1 mb-1 " >mdi-account-circle</v-icon>
          {{ runtimeStore.session.user?.first_name }}
        </p> -->

        <!-- "username": "marco",
  "is_superuser": true,
  "first_name": "Marco M.",
  "last_name": "",
  "is_staff": true,

  "pk": 63,
  "is_active": true,
  "email": "marco.milone@gmail.com" -->
        <!-- <pre>{{ runtimeStore.session }}</pre> -->
        <v-table>
          <tbody>
            <tr>
              <th>Username</th>
              <td>{{ runtimeStore.session.user?.username }}</td>
            </tr>
            <tr>
              <th>Nome</th>
              <td>{{ runtimeStore.session.user?.first_name }}</td>
            </tr>
            <tr>
              <th>Gruppi</th>
              <td>
                <v-chip variant="flat" color="blue-grey" class="my-1 mr-1" v-for="group in runtimeStore.session.user?.groups"
                    :key="group">
                  {{ group }}
                </v-chip>
              </td>
            </tr>
            <tr>
              <th>E-mail</th>
              <td>{{ runtimeStore.session.user?.email }}
              </td>
            </tr>
            <tr v-if="runtimeStore.session.user?.is_superuser == true">
              <th>Super</th>
              <td><v-icon color="green-darken-2">mdi-check</v-icon></td>
            </tr>
            <tr v-if="runtimeStore.session.user?.is_staff == true">
              <th>Staff</th>
              <td><v-icon color="green-darken-2">mdi-check</v-icon></td>
            </tr>
          </tbody>
        </v-table>


        <p class="text-title-medium  text-grey-darken-2 mt-4">Operazioni</p>

        <!-- <v-btn prepend-icon="mdi-email" class="mb-4" color="orange-darken-3" :block="mobile"
        @click="newEmail = runtimeStore.session.user?.email || ''"        
        >Cambia email
                  <v-dialog 
                  v-model="dialogEmail" 
                  activator="parent"
                  name="e-mail"
                  width="auto"
                  theme="dark"
                  :persistent="lockLogout">
                    <v-card>
                      <v-card-item>
                        <v-card-title> {{ t("logout_label") }}</v-card-title>
                        <v-card-subtitle>Stai per modificare l'email collegata</v-card-subtitle>
                      </v-card-item>
                      <v-card-text>
                        <p class="mb-5">
                          La tua email attuale: <br>
                          {{ runtimeStore.session.user?.email }}
                        </p>
                        <p class="mb-2">
                          <v-text-field v-model="newEmail" label="Nuova e-mail" placeholder="tua-email@pngp.it" />
                        </p>
                      </v-card-text>

                      <v-card-actions class="flex-column" >
                        <v-btn size="large" variant="elevated" color="primary" @click="changeMail">
                          Modifica</v-btn>
                        <v-btn size="large" variant="outlined" color="white" @click="dialogEmail = false"
                            class="mx-0 my-3">
                          <v-icon class="mr-2">mdi-chevron-down</v-icon>
                          Indietro</v-btn>
                      </v-card-actions>
                    </v-card>
                </v-dialog>

        </v-btn>
        <br> -->


        <v-btn prepend-icon="mdi-key" class="mb-4" color="orange-darken-3" :block="mobile">Cambia password
          <v-dialog v-model="dialogPassword" activator="parent" width="auto" theme="dark">
            <form @submit.prevent="submitChangePasswordRequest" id="change-password">
              <v-card>
                <v-card-item>
                  <v-card-title>Cambia password</v-card-title>
                  <v-card-subtitle>Stai per modificare la password.</v-card-subtitle>
                </v-card-item>
                <v-card-text>
                  <p class="mb-5">
                    Per effettuare la modifica è necessario essere collegati ad internet.<br>
                    <strong v-if="!online">In questo momento non sei collegato ad internet.</strong>
                  </p>

                  <input type="text" autocomplete="username" name="username"
                      :value="runtimeStore.session.user?.username" style="display: none;" />

                  <v-text-field v-model="chgpwd.old_password" label="Vecchia password" autocomplete="current-password"
                      :append-icon="!showOldPwd ? 'mdi-eye' : 'mdi-eye-off'" :type="showOldPwd ? 'text' : 'password'"
                      @click:append="showOldPwd = !showOldPwd"
                      @keypress.enter="submitChangePasswordRequest"></v-text-field>

                  <v-text-field v-model="chgpwd.new_password" label="Nuova password" autocomplete="new-password"
                      :append-icon="!showNewPwd ? 'mdi-eye' : 'mdi-eye-off'" :type="showNewPwd ? 'text' : 'password'"
                      @click:append="showNewPwd = !showNewPwd"
                      @keypress.enter="submitChangePasswordRequest"></v-text-field>

                  <v-text-field v-model="chgpwd.new_password_repeat" label="Ripeti nuova password"
                      autocomplete="new-password"
                      :append-icon="chgpwd.new_password === chgpwd.new_password_repeat ? 'mdi-check' : 'mdi-alert-outline'"
                      :type="showNewPwd ? 'text' : 'password'"
                      @keypress.enter="submitChangePasswordRequest"></v-text-field>


                  <p>
                    La qualità della password è valutata in base alla lunghezza e alla presenza di caratteri speciali.
                  </p>
                  <p v-if="passwordQuality == 0" class="my-2 text-red-lighten-2">
                    La password è troppo debole, non accettabile.
                  </p>
                  <p v-if="passwordQuality == 1" class="my-2 text-red-lighten-2">
                    La password è debole, non accettabile.
                  </p>
                  <p v-if="passwordQuality == 2" class="my-2 text-yellow-lighten-2">
                    La password è media, accettabile.
                  </p>
                  <p v-if="passwordQuality == 3" class="my-2 text-green-lighten-2">
                    La password è forte, accettabile.
                  </p>
                  <p v-if="chgpwd.new_password != chgpwd.new_password_repeat" class="my-2 text-red-lighten-2">
                    Il campo "ripeti" non coincide.
                  </p>

                </v-card-text>

                <v-card-actions class="flex-column">
                  <v-btn size="large" variant="elevated" color="blue-darken-3" type="submit"
                      form="change-password" :disabled="!passwordButtonEnabled">
                    <v-icon class="mr-2">mdi-pencil</v-icon> Modifica</v-btn>
                  <v-btn size="large" variant="outlined" color="white" @click="dialogPassword = false"
                      class="mx-0 my-3">
                    <v-icon class="mr-2">mdi-chevron-down</v-icon>
                    Indietro</v-btn>
                </v-card-actions>
              </v-card>
            </form>
          </v-dialog>
        </v-btn>



        <p class="text-title-large text-grey-darken-2">Autenticazione</p>
        <p class="text-title-medium text-grey-darken-2">Token</p>

        <p>
          <v-icon :color="testTokenStatus.iconColor" size="small" class=" mr-2">{{ testTokenStatus.iconText
            }}</v-icon>
          <strong>{{ testTokenStatus.title }}</strong><br>
          <template v-if="ENVIRONMENT === 'production'">
          {{ runtimeStore?.session?.user?.token.substring(0, 5) }}{{ "*".repeat(15) }} <br>
          </template>
          <template v-else>
          {{ runtimeStore?.session?.user?.token }} <br>
          </template>
          
          <span v-html="testTokenStatus.text"></span>
        </p>


        <!-- <tokens-manager  /> -->
        <tokens-manager v-if="testTokenStatus.result" />

        <p class="text-title-medium text-grey-darken-2">Connessione</p>

        <v-btn prepend-icon="mdi-logout" class="mb-4" color="red-darken-3"  :block="mobile">
          disconnetti

          <v-dialog v-model="dialogLogout" activator="parent" width="auto" theme="dark"  :persistent="lockLogout">
            <v-card>
              <v-card-item>
                <v-card-title> {{ t("logout_label") }}</v-card-title>
                <v-card-subtitle>Stai per effettuare la disconnessione.</v-card-subtitle>
              </v-card-item>
              <v-card-text>
                <p class="mb-2">
                  Se effettui la disconnessione non potrai continuare a lavorare.<br>
                  Dovrai collegarti nuovamente (con questo utente o uno differente) per continuare.<br>
                  Per effettuare una nuova connessione è necessario essere collegati ad internet.<br>
                </p>
                <p class="mb-2" v-if="!online">
                  <strong>In questo momento non sei collegato ad internet.
                    <br>
                    La funzionalità di connessione non funzionerà, senza la connettività.</strong>
                </p>
                <p v-else>
                  Sei davvero sicuro di voler continuare?
                </p>
              </v-card-text>

              <v-card-actions class="flex-column" >
                <v-btn :disabled="lockLogout" size="large" variant="elevated" color="red-darken-3" @click="logoutClicked">
                  <v-icon v-if="!lockLogout" class="mr-2">mdi-logout</v-icon>
                  <v-icon v-else class="mr-2">mdi-dots-circle mdi-spin</v-icon>
                  Disconnetti</v-btn>
                <v-btn :disabled="lockLogout" size="large" variant="outlined" color="white" @click="dialogLogout = false"
                    class="mx-0 my-3">
                  <v-icon class="mr-2">mdi-chevron-down</v-icon>
                  Indietro</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-btn>
        <br>

        <v-divider class="mt-4"/>


        <p class="text-headline-small mt-4">Dati</p>
        <p class="text-title-large  text-grey-darken-2 mt-4">Scarica</p>

        Scarica i dati raccolti dall'utente attualmente connesso.<br>
        I dati non vengono modificati.<br>

        <v-btn prepend-icon="mdi-download" class="mt-2 mb-4" color="blue-darken-3" :block="mobile"
         @click="downloadLocalStorageUserData">
          Scarica
        </v-btn>

        <div v-if="runtimeStore.session.user?.is_superuser === true" class="">
        <p class="text-title-large  text-grey-darken-2 mt-4">Ripristina
          <v-icon size="x-small" color="orange" class="mb-1">mdi-alert</v-icon></p>

        Ripristina i dati raccolti al posto di quelli attuali.<br>

        <strong>I dati attuali verranno sovrascritti!!!</strong><br>

        
        <v-file-input v-model="restoreJSONFile" 
          label="Seleziona JSON da ripristinare"
          hide-details
          :prepend-icon="null"
          append-icon="mdi-attachment"
        >
          </v-file-input>
                <v-btn prepend-icon="mdi-restore" class="mt-2 mb-4" color="green-darken-3" :block="mobile"
                @click="restoreLocalStorageUserData"
                :disabled="!restoreJSONFile">
                  Ripristina
                </v-btn>
          </div>



        <p class="text-title-large  text-grey-darken-2 mt-4">Elimina
          <v-icon size="x-small" color="orange" class="mb-1">mdi-alert</v-icon>
        </p>
        Elimina i dati raccolti dall'utente attualmente connesso ({{ runtimeStore.session.user?.first_name }}).<br>
        <strong>Elimina anche i dati non ancora inviati.</strong><br>

        <v-btn prepend-icon="mdi-delete" class="mt-2 mb-4" color="red-darken-3" :block="mobile">
          Elimina

          <v-dialog v-model="dialogDeleteAllUserData" activator="parent" width="auto" theme="dark">
            <v-card>
              <v-card-item>
                <v-card-title> Eliminazione dati utente</v-card-title>
                <v-card-subtitle>Stai per eliminare tutti i dati raccolti.</v-card-subtitle>
              </v-card-item>
              <v-card-text>
                <p class="mb-2">
                  Stai per eliminare tutti i dati raccolti (anche quelli non inviati al server) dall'utente attualmente
                  collegato.
                </p>
                <p class="mb-2">
                  Non saranno più recuperabili.
                </p>
                <p class="font-weight-bold mb-2">
                  Sei davvero sicuro di voler continuare?
                </p>
                <p class="mb-4">
                  Scrivi il tuo nome utente ( <span class="text-yellow">{{ runtimeStore.session.user?.username }}</span>
                  )
                  qui sotto<br>per abilitare il bottone per continuare.
                </p>
                <p>
                  <v-text-field v-model="usernameConfirmation" placeholder="nomeutente" />
                </p>
              </v-card-text>

              <v-card-actions class="flex-column">
                <v-btn size="large" variant="elevated" color="red-darken-3" @click="deleteUserData"
                    :disabled="usernameConfirmation != runtimeStore.session.user?.username">
                  <v-icon class="mr-2">mdi-delete</v-icon> Elimina</v-btn>
                <v-btn size="large" variant="outlined" color="white"
                    @click="dialogDeleteAllUserData = false" class="mx-0 my-3">
                  <v-icon class="mr-2">mdi-chevron-down</v-icon>
                  Indietro</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-btn>















        <div v-if="runtimeStore.session.user?.is_superuser === true" class="">
        <v-divider />
        <p class="text-headline-small mt-5">Superadmin
          🦸‍♂️
        </p>


        <p class="text-title-large  text-grey-darken-2 mt-2">Accedi come altro utente</p>
          Recupera le credenziali di un altro utente<br>


          <v-btn prepend-icon="mdi-account-box-multiple" class="mt-2 mb-4" color="red-darken-3" :block="mobile">
            Impersona
          

            <v-dialog v-model="dialogImpersonate" activator="parent" width="auto" theme="dark">
              <v-card>
                <v-card-item>
                  <v-card-title>Dati utente</v-card-title>
                  <v-card-subtitle>Stai per connetterti come {{ new_username_to_connect_as }}.</v-card-subtitle>
                </v-card-item>
                <v-card-text>
                  <v-text-field v-model="new_username_to_connect_as" placeholder="nome_utente">
                    <template v-slot:append>
                      <v-btn size="" variant="elevated" color="orange-darken-3" @click="getUserAuth">
                        <v-icon class="pa-6">mdi-download</v-icon></v-btn>
                    </template>
                  </v-text-field>
                  <pre>{{ newUserData }}</pre>
                  
                  
                </v-card-text>
  
                <v-card-actions class="flex-column">
                    
                  <v-btn size="large" v-if="!!newUserData?.user?.token"
                  variant="elevated" color="blue-darken-3" @click="useAuthUserData">
                    <v-icon class="mr-2" color="yellow">mdi-account</v-icon> Impersona</v-btn>
                  <v-btn size="large" variant="outlined" color="white"
                      @click="dialogImpersonate = false" class="mx-0 my-3">
                    <v-icon class="mr-2">mdi-chevron-down</v-icon>
                    Indietro</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-btn>
        </div>

      </v-card-text>
    </div>


    
  </v-card>
</template>

<script setup>

import router from "@/router";
import { useI18n } from "vue-i18n";
import { useRuntimeStore } from "@/store/runtime"
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useDataStore } from "@/store/data"

import { useNetworkStore } from "@/store/network"
import { passwordStrength } from 'check-password-strength'

import TokensManager from "@/pages/components/TokensManager.vue"


import { useToastsStore } from "@/store/toasts";

// import cg from "@/service/colorGenerator";

import { useApi } from "@/service/api";

import { useDisplay } from 'vuetify'

const { mobile } = useDisplay()



const toastsStore = useToastsStore();

// import { getUserAgent } from "universal-user-agent"
// import { UAParser } from "ua-parser-js"

// const getDevice = () => {
  //   const userAgent = getUserAgent()
  //   let parser = new UAParser(userAgent); // you need to pass the user-agent for nodejs
  //   // console.log(parser); // {}
  //   let device = parser.getResult();
  //   console.log(device);
//   // create a readable string from the device object
//   return device;
// }

// const getDeviceId = () => {
  //   let device = getDevice();
  //   console.log(device);
  //   let deviceId = `${device?.browser?.name}@${device?.os?.name}_${device?.os?.version}_${device?.cpu?.architecture}`
//   // return device;
//   return deviceId;
// }

// const device = ref(getDevice())
// const deviceId = ref(getDeviceId())



const newEmail = ref("")

const new_username_to_connect_as = ref("mainetti_a")
const newUserData = ref({})

const api = useApi()
const networkStore = useNetworkStore();

const dataStore = useDataStore();

const online = ref(false);

const usernameConfirmation = ref("");





window.ononline = function () {
  online.value = true;
}

window.onoffline = function () {
  online.value = false;
}



const dialogImpersonate = ref(false);

const getUserAuth = async () => {
  const result = await api.tracker.getUserAuth( new_username_to_connect_as.value )
  newUserData.value = result.data
}

const useAuthUserData = () => {
  console.log(newUserData.value.user)
  runtimeStore.saveUserData(newUserData.value.user)

  dialogImpersonate.value = false
  toastsStore.toast({
            title: 'Account',
            text: 'nuovo utente',
            type: 'success',
      })
}


// const { t, locale } = useI18n({
// });

const { t } = useI18n({
});


const testTokenStatus = ref({
  result: false,
  iconColor: '',
  iconText: '',
  title: '',
  text: '',
})


const chgpwd = ref({
  old_password: '',
  new_password: '',
  new_password_repeat: '',
})


const showNewPwd = ref(false)
const showOldPwd = ref(false)


const passwordQuality = computed(() => {
  return passwordStrength(chgpwd.value.new_password).id
})

const checkPasswordButtonEnabled = () => {
  if (passwordQuality.value < 2) {
    console.log("password debole")
    return false
  }
  if (chgpwd.value.new_password == chgpwd.value.old_password) {
    console.log("nuova uguale vecchia")
    return false
  }
  if (chgpwd.value.new_password != chgpwd.value.new_password_repeat) {
    console.log("password diverse")
    return false
  }

  return true
}

const passwordButtonEnabled = computed(() => {
  return checkPasswordButtonEnabled()
})


const submitChangePasswordRequest = async () => {
  console.log("submitChangePasswordRequest fired")
  const data = {
    "old": chgpwd.value.old_password,
    "new": chgpwd.value.new_password,
  }
  const result = await api.tracker.userChangePassword(data)

  console.log(result)

  if (result?.success) {
    console.log(result.message)
  }
  else {
    console.log(result.message)
  }

  dialogPassword.value = false
}


const runtimeStore = useRuntimeStore();

const dialogLogout = ref(false);
const dialogEmail = ref(false);

const dialogDeleteAllUserData = ref(false);
const dialogResetSettings = ref(false);

const dialogPassword = ref(false);

const lockLogout = ref(false);

const logoutClicked = async () => {

  lockLogout.value = true

  const logoutResult = await api.tracker.logout()

  console.log(logoutResult)
  if (logoutResult.response === undefined) {
    const text = `Sta per avvenire la "disconnessione".
    
    Non è stato possibile comunicare con il server.
    Per invalidare l'attuale token con cui è collegato il dispositivo,
    eliminarlo manualmente tramite l'interfaccia di gestione autenticazioni.
    Se il token non verrà utilizzato per 60 giorni, la validità decadrà automaticamente.
    `
    toastsStore.toast({
            title: 'Logout',
            text: text,
            type: 'warning',
            showUICountdown: true,
            duration: 20000,
            callbackOnHide: logoutOperations
      })
      return
  }

  if (logoutResult?.data?.success === true) {
    logoutOperations()
  }

  if (logoutResult.response.status === 401) {
    logoutOperations()
  }


}


const logoutOperations = async () => {
  lockLogout.value = false  
  // console.log("adesso effettuo il logout")
  // return
  // console.log("logout result", result)
  runtimeStore.logout();
  dialogLogout.value = false;
  router.push({ name: 'login' })
}




const downloadLocalStorageUserData = () => {
  // 1. Collect all data from localStorage
  const data = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    const value = localStorage.getItem(key);
    
    // Optional: Try to parse JSON strings back into objects
    try {
      data[key] = JSON.parse(value);
    } catch (e) {
      data[key] = value;
    }
  }

  // 2. Convert the object to a JSON string
  const jsonString = JSON.stringify(data, null, 2);

  // 3. Create a Blob and a hidden download link
  const blob = new Blob([jsonString], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  const timestamp = new Date().toISOString()
    .replace(/[:.]/g, '-')  // Replace colons and dots with dashes
    .slice(0, 19);         // Cut off the milliseconds at the end

  link.href = url;
  link.download = `localstorage_backup_${runtimeStore.session.user?.pk}__${timestamp}.json`;
  
  // 4. Trigger the download and cleanup
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};


const restoreJSONFile = ref(null)

const restoreLocalStorageUserData = (event) => {
  const file = restoreJSONFile?.value;
  if (!file) return;

  const reader = new FileReader();

  reader.onload = (e) => {
    try {
      const data = JSON.parse(e.target.result);

      // 1. Optional: Clear existing data first?
      // localStorage.clear();

      // 2. Iterate through the object and save to localStorage
      Object.keys(data).forEach((key) => {
        let value = data[key];

        // If the value is an object/array, we must stringify it back
        if (typeof value === "object" && value !== null) {
          value = JSON.stringify(value);
        }

        localStorage.setItem(key, value);
      });

      alert("Data restored successfully!");
      window.location.reload(); // Reload to apply changes to the UI
    } catch (err) {
      console.error("Error parsing the JSON file:", err);
      alert("Failed to restore data. Make sure the file is a valid JSON.");
    }
  };

  reader.readAsText(file);
};




const deleteUserData = () => {
  dataStore.deleteUserData()
  dialogDeleteAllUserData.value = false
  window.location.reload()

  // router.push({name:'settings'})
}


const changeMail = async () => {
  console.log("not implemented yet")
}


onMounted(() => {

  online.value = navigator.onLine;

  newEmail.value = runtimeStore.session.user?.email || ""

  setTimeout(secure_data_test_get, 300)

})




onUnmounted(() => {

})



const networkData = {};
for (const key in navigator.connection) {
  if (typeof navigator.connection[key] !== "function") {
    networkData[key] = navigator.connection[key];
  }
}
console.log(JSON.stringify(networkData));
console.log(networkData);


const secure_data_test_get = async () => {

console.log("🧠 testToken against tracker api")

testTokenStatus.value.result = false
testTokenStatus.value.iconColor = "red-darken-2"
testTokenStatus.value.iconText = "mdi-dots-circle mdi-spin"
testTokenStatus.value.title = "Controllo in corso"
testTokenStatus.value.text = "Attendere..."

if (!networkStore.online) {
  testTokenStatus.value.result = false
  testTokenStatus.value.iconColor = "grey-darken-2"
  testTokenStatus.value.iconText = "mdi-wifi-off"
  testTokenStatus.value.title = "Offline"
  testTokenStatus.value.text = "Non è possibile effettuare il controllo"
  return
}



if (networkStore.trackerServerStatus === false) {
  testTokenStatus.value.result = false
  testTokenStatus.value.iconColor = "grey-darken-2"
  testTokenStatus.value.iconText = "mdi-server-off"
  testTokenStatus.value.title = "Server non raggiungibile"
  testTokenStatus.value.text = "Non è possibile raggiungere il server, per validare l'autenticazione"
  return
}


const result = await api.tracker.sdtg()

console.log(result)

if (result?.response){

  if (result?.response?.status >= 200 && result?.response?.status < 300) {
    testTokenStatus.value.result = true
    testTokenStatus.value.iconColor = "green-darken-2"
    testTokenStatus.value.iconText = "mdi-check"
    testTokenStatus.value.title = "Autenticazione riconosciuta"
    testTokenStatus.value.text = "L'applicazione può comunicare con il server."
  }
  else {
    testTokenStatus.value.result = false
    testTokenStatus.value.iconColor = "orange-darken-2"
    testTokenStatus.value.iconText = "mdi-alert"
    testTokenStatus.value.title = "Autenticazione non riconosciuta (scaduto?)"
    testTokenStatus.value.text = "L'applicazione non può comunicare con il server.<br>Il token scade automaticamente dopo 60 giorni di inutilizzo<br>È necessario effettuare nuovamente il login."
  }
}
  
  
}

</script>

<style scoped>
#fluidColumn {
  column-gap: 4em;
  column-width: 32em;
  column-count: auto;
  column-rule: 1px solid #ddd;
  /* column-count: 3; */
  widows: 3;
  orphans: 3;
}

.disable-events {
  pointer-events: none;
  opacity: .8;
}
</style>
